exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-black-text label {\n  color: #080808 !important;\n  font-weight: 400 !important;\n}\n.radio-buttons > *:nth-child(odd) {\n  background-color: #e9f1fb;\n}", ""]);

// exports
